@if(show)
{
<div class="notification-modal-overlay"></div>
<div class="notification-container">
  <span class="notification-text">{{brand?brand:"Our website"}} uses cookies to give you the best experience. By continuing to browse you are agreeing to our use of cookies. <a href="/Privacy/#cookiesAndOtherTechnologies">More details</a></span>
  <div class="notification-button">
    <a class="notification-link" (click)="close()">Got it!</a>
  </div>
</div>
}
